function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.5,13.2798004h-1v11.8500004l-3.5100002-3.5100002l-0.71,0.7099991L20,27.0498009l0.5-0.4800014V13.2798004z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.5400009,25.5098l3.1799984-3.1800003l-0.7099991-0.7099991l-2.4699993,2.4699993V25.5098z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      "enableBackground": "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/down-arrow.50e09a17.svg";
export { SvgComponent as ReactComponent };